import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import CreateEntity from 'components/crud/CreateEntity';
import { useTranslation } from 'react-i18next';
import GroupForm from '../../components/GroupForm';
import { IInputs } from '../../components/types';

const CreateForm: FC = () => {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const methods = useForm<IInputs>();
  const { client } = useActiveClientContext();

  return (
    <CreateEntity
      entity="groups"
      methods={methods}
      onSuccess={(res: any) => {
        const { name } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              {t('structure.groups.createSuccessMsg')} <span className="font-weight-bold text-break">{name}</span>.
            </>
          ),
        });
      }}
      queryKey={buildClientEntity('groups', client)}
      onSuccessPushToLink={buildClientUrl('/structure/groups', client)}
    >
      {(create: any) => (
        <GroupForm
          title={t('structure.groups.createTitle')}
          methods={methods}
          handleSubmit={create}
          btnLabel={t('common.save')}
        />
      )}
    </CreateEntity>
  );
};

export default CreateForm;
